import { render } from "./LayoutSystem.vue?vue&type=template&id=ce2c4312&ts=true"
import script from "./LayoutSystem.vue?vue&type=script&lang=ts"
export * from "./LayoutSystem.vue?vue&type=script&lang=ts"

import "./LayoutSystem.vue?vue&type=style&index=0&id=ce2c4312&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__